import { render, staticRenderFns } from "./received.vue?vue&type=template&id=77d24c4c&scoped=true"
import script from "./received.vue?vue&type=script&lang=js"
export * from "./received.vue?vue&type=script&lang=js"
import style0 from "./received.vue?vue&type=style&index=0&id=77d24c4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d24c4c",
  null
  
)

export default component.exports